import React, { useEffect, useState } from "react";
import axios from "axios";
import { Activity, Plus, Trash2, Edit3, ShieldAlert, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { API_BASE_LOCAL_URL } from "../../../config";

export default function ActivityLogsCard() {
  const [logs, setLogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${API_BASE_LOCAL_URL}/api/admin/audits?page=0&size=4`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLogs(res.data.content);
    } catch (err) {
      console.error("Audit fetch failed", err);
    }
  };

  const getIcon = (action) => {
    if (action === "CREATE") return <Plus size={14} />;
    if (action === "DELETE") return <Trash2 size={14} />;
    if (action === "UPDATE") return <Edit3 size={14} />;
    return <ShieldAlert size={14} />;
  };

  const getStatusColor = (action) => {
    if (action === "CREATE") return "#198754"; // Success Green
    if (action === "DELETE") return "#dc3545"; // Danger Red
    if (action === "UPDATE") return "#0d6efd"; // Primary Blue
    return "#6c757d"; // Secondary Gray
  };

  return (
    <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">
      {/* HEADER */}
      <div className="card-header bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <div className="bg-success bg-opacity-10 p-2 rounded-3">
            <Activity size={18} className="text-success" />
          </div>
          <h6 className="fw-bold mb-0 text-dark">Recent Activity</h6>
        </div>
        <button
          onClick={() => navigate("/AdminDashboard/activity-logs")}
          className="btn btn-link text-decoration-none text-primary fw-bold p-0 small-text"
          style={{ fontSize: '0.75rem' }}
        >
          View Full Log <ChevronRight size={14} />
        </button>
      </div>

      {/* BODY */}
      <div className="card-body px-4 pt-2 pb-4">
        {logs.length === 0 ? (
          <div className="text-center py-5">
            <p className="text-muted small">No recent activity detected.</p>
          </div>
        ) : (
          <div className="timeline-container position-relative">
            {/* The Vertical Line */}
            <div 
              className="position-absolute start-0 h-100 border-start border-light-subtle" 
              style={{ marginLeft: '15px', zIndex: 0, top: '10px' }}
            ></div>

            {logs.map((log, index) => (
              <div key={log.id} className="d-flex align-items-start mb-4 position-relative" style={{ zIndex: 1 }}>
                
                {/* ICON CIRCLE */}
                <div 
                  className="rounded-circle d-flex align-items-center justify-content-center shadow-xs"
                  style={{ 
                    minWidth: '32px', 
                    height: '32px', 
                    backgroundColor: '#fff',
                    border: `2px solid ${getStatusColor(log.action)}20`,
                    color: getStatusColor(log.action)
                  }}
                >
                  {getIcon(log.action)}
                </div>

                {/* CONTENT */}
                <div className="ms-3 w-100">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <p className="mb-0 text-dark fw-bold" style={{ fontSize: '0.85rem' }}>
                        {log.username}
                        <span 
                          className="ms-2 fw-bold text-uppercase" 
                          style={{ fontSize: '0.65rem', color: getStatusColor(log.action), letterSpacing: '0.5px' }}
                        >
                          {log.action}
                        </span>
                      </p>
                      <p className="mb-0 text-muted" style={{ fontSize: '0.75rem' }}>
                        Modified <span className="text-dark fw-medium">{log.module}</span> record
                      </p>
                    </div>
                    <time className="text-muted fw-medium" style={{ fontSize: '0.65rem' }}>
                      {new Date(log.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </time>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <style>{`
        .small-text { font-size: 0.75rem; }
        .shadow-xs { box-shadow: 0 1px 3px rgba(0,0,0,0.05); }
        .timeline-container div:last-child .border-start {
          display: none;
        }
      `}</style>
    </div>
  );
}